import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';

export interface VertexCredentialsPayload {
  url: string;
  client_id: string;
  client_secret: string;
  grant_type: string;
  audience: string;
}

export default class VertexApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getCredentials(): Promise<any> {
    return super.get(api.vertex_credentials);
  }

  public async createCredentials(payload: VertexCredentialsPayload): Promise<any> {
    return super.post(api.vertex_credentials, payload);
  }

  public async updateCredentials(id: string, payload: VertexCredentialsPayload): Promise<any> {
    return super.put(api.vertex_credentials + '/' + id, payload);
  }

  public async testCredentials(payload: VertexCredentialsPayload): Promise<any> {
    return super.post(api.vertex_credentials_test, payload);
  }
}
